import { render, staticRenderFns } from "./SSO.vue?vue&type=template&id=61e3ef56&scoped=true&"
import script from "./SSO.vue?vue&type=script&lang=js&"
export * from "./SSO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e3ef56",
  null
  
)

export default component.exports